export const getAppRatingPercents = (rating: number) => rating * 20;
